import { Identity } from "../functions/Identity"
import type { AsyncSequence } from "../types/AsyncSequence"
import { MapAsync } from "./MapAsync"

export const ArrayToIterable = <T>(
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<T> => MapAsync(Identity, ...arrays)
